import Vue from 'vue'
import Router from 'vue-router'
import auth from '../src/middleware/auth'
import loggedIn from '../src/middleware/loggedIn'
import logout from '../src/middleware/logout'
import store from '@/store.js'
import axios from 'axios'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        // Dashboard
        {
          name: 'taskDesk',
          path: 'taskDesk',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/Dashboard'),
        },
        {
          path: '/reportViewer/index',
          name: 'reportViewer',
          props: true,
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/components/general/printViewer/printViewer'),
        },

        {
          name: 'Home',
          path: 'home',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/home'),
        },
        {
          name: 'profile',
          path: 'users/profile',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/General/profile.vue'),
        },
        {
          name: 'Dashboard',
          path: '',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/widgets/fixGrid'),
        },
        // account
        {
          name: 'customer',
          path: 'customer',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/account/customer'),
          props: true,
        },
        {
          name: 'customerEdit',
          path: 'customer/edit/:id?',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/account/customer'),
          props: true,
        },
        {
          name: 'customerList',
          path: 'customer/list',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/account/list'),
          props: true,
        },
        {
          name: 'businessList',
          path: 'business/list',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/account/businessList'),
          props: true,
        },
        {
          name: 'usersList',
          path: 'users/list',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/account/list'),
          props: true,
        },
        {
          name: 'leadList',
          path: 'lead/list',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/account/list'),
          props: true,
        },
        {
          name: 'debtorList',
          path: 'debtor/list',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/account/list'),
          props: true,
        },
        {
          name: 'creditorList',
          path: 'creditor/list',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/account/list'),
          props: true,
        },
        {
          name: 'TaskList',
          path: 'task/list',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/task/list'),
          props: true,
        },
        {
          name: 'task',
          path: 'task/index',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/task/task'),
          props: true,
        },
        {
          name: 'taskEdit',
          path: 'task/edit/:id?',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/task/task'),
          props: true,
        },
        {
          name: 'iframe',
          path: 'ov',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/iframe'),
          props: true,
        },
        {
          name: 'SellProducts',
          path: 'sell/products',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/components/general/productList/ProductList'),
          props: true,
        },
        {
          name: 'SellPrint',
          path: 'sell/print/:id?',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/sell/print'),
          props: true,
        },
        // academy
        {
          name: 'academyCategory',
          path: 'academy/category/index',
          component: () => import('@/views/dashboard/pages/academy/category'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'academyCategoryList',
          path: 'academy/category/list',
          component: () => import('@/views/dashboard/pages/academy/categoryList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'academyCategoryEdit',
          path: 'academy/category/edit/:id?',
          component: () => import('@/views/dashboard/pages/academy/category'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'academyPlace',
          path: 'academy/place/index',
          component: () => import('@/views/dashboard/pages/academy/place'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'academyPlaceEdit',
          path: 'academy/place/edit/:id?',
          component: () => import('@/views/dashboard/pages/academy/place'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'academyPlaceList',
          path: 'academy/place/list',
          component: () => import('@/views/dashboard/pages/academy/placeList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'academyEvent',
          path: 'academy/event/index',
          component: () => import('@/views/dashboard/pages/academy/event'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'academyEventEdit',
          path: 'academy/event/edit/:id?',
          component: () => import('@/views/dashboard/pages/academy/event'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'academyStudentList',
          path: 'academy/student/list',
          component: () => import('@/views/dashboard/pages/account/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'academyTeacherList',
          path: 'academy/teacher/list',
          component: () => import('@/views/dashboard/pages/account/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'academyTeacherSessionCostList',
          path: 'academy/teacher/cost/list',
          component: () => import('@/views/dashboard/pages/academy/teacherSessionCostList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'academyEventStudent',
          path: 'academy/event/student',
          component: () => import('@/views/dashboard/pages/academy/eventStudent'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'academyEventStudentList',
          path: 'academy/event/studentlist',
          component: () => import('@/views/dashboard/pages/academy/eventStudentList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'academyEventList',
          path: 'academy/Event/list',
          component: () => import('@/views/dashboard/pages/academy/eventList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'academySessionList',
          path: 'academy/session/list',
          component: () => import('@/views/dashboard/pages/academy/sessionList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'academyDashboard',
          path: 'academy/dashboard',
          component: () => import('@/views/dashboard/pages/academy/dashboard'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'academyStudentAttendance',
          path: 'academy/student/attendance',
          component: () => import('@/views/dashboard/pages/academy/studentAttendance'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'academyEventStudentAttandance',
          path: 'academy/student/eventattendance',
          component: () => import('@/views/dashboard/pages/academy/eventStudentAttendanceList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        // cost
        {
          name: 'cost',
          path: 'cost/index',
          component: () => import('@/views/dashboard/pages/cost&income/cost'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        // cost
        {
          name: 'commission',
          path: 'commission/index',
          component: () => import('@/views/dashboard/pages/cost&income/cost'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'commissionEdit',
          path: 'commission/edit/:id?',
          component: () => import('@/views/dashboard/pages/cost&income/cost'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'returnCommission',
          path: 'returnCommission/index',
          component: () => import('@/views/dashboard/pages/cost&income/cost'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'returnCommissionList',
          path: 'returnCommission/list',
          component: () => import('@/views/dashboard/pages/cost&income/costList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'returnShippingList',
          path: 'returnShipping/list',
          component: () => import('@/views/dashboard/pages/cost&income/costList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'shippingList',
          path: 'shipping/list',
          component: () => import('@/views/dashboard/pages/cost&income/costList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'processingList',
          path: 'processing/list',
          component: () => import('@/views/dashboard/pages/cost&income/costList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'returnProcessingList',
          path: 'returnProcessing/list',
          component: () => import('@/views/dashboard/pages/cost&income/costList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'durabilityInEntrepotList',
          path: 'durabilityInEntrepot/list',
          component: () => import('@/views/dashboard/pages/cost&income/costList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'penaltyCancellingList',
          path: 'penaltyCancelling/list',
          component: () => import('@/views/dashboard/pages/cost&income/costList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'contradictionProductInEnterList',
          path: 'contradictionProductInEnter/list',
          component: () => import('@/views/dashboard/pages/cost&income/costList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'returnCommissionEdit',
          path: 'returnCommission/edit/:id?',
          component: () => import('@/views/dashboard/pages/cost&income/cost'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'penalty',
          path: 'penalty/index',
          component: () => import('@/views/dashboard/pages/cost&income/cost'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'penaltyList',
          path: 'penalty/list',
          component: () => import('@/views/dashboard/pages/cost&income/costList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'penaltyEdit',
          path: 'penalty/edit/:id?',
          component: () => import('@/views/dashboard/pages/cost&income/cost'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'income',
          path: 'income/index',
          component: () => import('@/views/dashboard/pages/cost&income/cost'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'costList',
          path: 'cost/list',
          component: () => import('@/views/dashboard/pages/cost&income/costList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'incomeList',
          path: 'income/list',
          component: () => import('@/views/dashboard/pages/cost&income/costList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'costEdit',
          path: 'cost/edit/:id?',
          component: () => import('@/views/dashboard/pages/cost&income/cost'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'incomeEdit',
          path: 'income/edit/:id?',
          component: () => import('@/views/dashboard/pages/cost&income/cost'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'transfer',
          path: 'transfer/cash/index',
          component: () => import('@/views/dashboard/pages/treasury/transfer'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'transferEdit',
          path: 'transfer/cash/edit/:id?',
          component: () => import('@/views/dashboard/pages/treasury/transfer'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'transferList',
          path: 'transfer/cash/list',
          component: () => import('@/views/dashboard/pages/treasury/transferList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'pay',
          path: 'pay/cash/index',
          component: () => import('@/views/dashboard/pages/treasury/payments'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'payEdit',
          path: 'pay/cash/edit/:id?',
          component: () => import('@/views/dashboard/pages/treasury/payments'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'recieveEdit',
          path: 'recieve/cash/edit/:id?',
          component: () => import('@/views/dashboard/pages/treasury/payments'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'payList',
          path: 'pay/cash/list',
          component: () => import('@/views/dashboard/pages/treasury/paymentsList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'removedPayments',
          path: 'payments/removedList',
          component: () => import('@/views/dashboard/pages/treasury/paymentsList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'recieve',
          path: 'receive/cash/index',
          component: () => import('@/views/dashboard/pages/treasury/payments'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'recieveEdit',
          path: 'receive/cash/edit/:id?',
          component: () => import('@/views/dashboard/pages/treasury/payments'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'compositeReceipt',
          path: 'receive/composite/index',
          component: () => import('@/views/dashboard/pages/treasury/composite'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'compositePayment',
          path: 'pay/composite/index',
          component: () => import('@/views/dashboard/pages/treasury/composite'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'recieveList',
          path: 'receive/cash/list',
          component: () => import('@/views/dashboard/pages/treasury/paymentsList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'Product',
          path: 'product/new',
          component: () => import('@/views/dashboard/pages/product/product'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'ProductEdit',
          path: 'product/edit/:id?',
          component: () => import('@/views/dashboard/pages/product/product'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'ProductList',
          path: 'product/list',
          component: () => import('@/views/dashboard/pages/product/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'VariantsList',
          path: 'variants/list',
          component: () => import('@/views/dashboard/pages/product/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'Variants',
          path: 'variants/:id?',
          component: () => import('@/views/dashboard/pages/product/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'labelPrintSetting',
          path: 'labelprint',
          component: () => import('@/views/dashboard/pages/product/partial/labelPrintSetting'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'processingProductCost',
          path: 'product/processingList',
          component: () => import('@/views/dashboard/pages/product/processingList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'productPerEntrepotList',
          path: 'product/entrepotList',
          component: () => import('@/views/dashboard/pages/product/entrepotList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'productPerEntrepotListSingle',
          path: 'product/entrepotList/:id?',
          component: () => import('@/views/dashboard/pages/product/entrepotList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'productTurnover',
          path: 'product/turnover',
          component: () => import('@/views/dashboard/pages/product/turnover'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'productTurnoverDetails',
          path: 'product/turnover/details',
          component: () => import('@/views/dashboard/pages/product/turnover'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'productTurnoverSingle',
          path: 'product/turnover/:id?',
          component: () => import('@/views/dashboard/pages/product/turnover'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'productCountTurnover',
          path: 'product/countTurnover/:id?',
          component: () => import('@/views/dashboard/pages/product/turnover'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'productAmountTurnover',
          path: 'product/amountTurnover/:id?',
          component: () => import('@/views/dashboard/pages/product/turnover'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'productPricing',
          path: 'product/pricing',
          component: () => import('@/views/dashboard/pages/product/pricingList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'productBarcode',
          path: 'product/barcode',
          component: () => import('@/views/dashboard/pages/product/barcode'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'Service',
          path: 'service/new',
          component: () => import('@/views/dashboard/pages/product/product'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'ServiceEdit',
          path: 'service/edit/:id?',
          component: () => import('@/views/dashboard/pages/product/product'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'ServiceList',
          path: 'service/list',
          component: () => import('@/views/dashboard/pages/product/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'warehouseHandling',
          path: 'entrepot/warehousehandling/new',
          component: () => import('@/views/dashboard/pages/Entrepot/index.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'warehouseHandlingEdit',
          path: 'entrepot/warehousehandling/edit/:id?',
          component: () => import('@/views/dashboard/pages/Entrepot/index.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'warehouseHandlingList',
          path: 'entrepot/warehousehandling/list',
          component: () => import('@/views/dashboard/pages/Entrepot/list.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'receipt',
          path: 'entrepot/receipt/new',
          component: () => import('@/views/dashboard/pages/Entrepot/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'receiptEdit',
          path: 'entrepot/receipt/edit/:id?',
          component: () => import('@/views/dashboard/pages/Entrepot/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'tempReceipt',
          path: 'entrepot/tempReceipt/new',
          component: () => import('@/views/dashboard/pages/Entrepot/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'tempReceiptEdit',
          path: 'entrepot/tempReceipt/edit/:id?',
          component: () => import('@/views/dashboard/pages/Entrepot/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'remittance',
          path: 'entrepot/remittance',
          component: () => import('@/views/dashboard/pages/Entrepot/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'transferProductStock',
          path: 'entrepot/transferProductStock',
          component: () => import('@/views/dashboard/pages/Entrepot/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'transferProductStockEdit',
          path: 'entrepot/transferProductStock/edit/:id?',
          component: () => import('@/views/dashboard/pages/Entrepot/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'transferProductStockList',
          path: 'entrepot/transferProductStockList',
          component: () => import('@/views/dashboard/pages/Entrepot/list.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'expireDateItems',
          path: 'entrepot/expireDateItems',
          component: () => import('@/views/dashboard/pages/Entrepot/expireDateItems'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'remittanceEdit',
          path: 'entrepot/remittance/edit/:id?',
          component: () => import('@/views/dashboard/pages/Entrepot/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'useRemittance',
          path: 'entrepot/useRemittance',
          component: () => import('@/views/dashboard/pages/Entrepot/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'useRemittanceEdit',
          path: 'entrepot/useRemittance/edit/:id?',
          component: () => import('@/views/dashboard/pages/Entrepot/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'transferRemittance',
          path: 'entrepot/transferRemittance',
          component: () => import('@/views/dashboard/pages/Entrepot/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'transferRemittanceEdit',
          path: 'entrepot/transferRemittance/edit/:id?',
          component: () => import('@/views/dashboard/pages/Entrepot/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'receiptList',
          path: 'entrepot/receipt/list',
          component: () => import('@/views/dashboard/pages/Entrepot/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'tempReceiptList',
          path: 'entrepot/tempReceipt/list',
          component: () => import('@/views/dashboard/pages/Entrepot/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'remittanceList',
          path: 'entrepot/remittance/list',
          component: () => import('@/views/dashboard/pages/Entrepot/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'useRemittanceList',
          path: 'entrepot/useRemittance/list',
          component: () => import('@/views/dashboard/pages/Entrepot/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'transferRemittanceList',
          path: 'entrepot/transferRemittance/list',
          component: () => import('@/views/dashboard/pages/Entrepot/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'accounting',
          path: 'accounting/new',
          component: () => import('@/views/dashboard/pages/accounting/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'balanceSheet',
          path: 'accounting/balanceSheet',
          component: () => import('@/views/dashboard/pages/accounting/balanceSheet'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'totalDocument',
          path: 'accounting/totalDocument',
          component: () => import('@/views/dashboard/pages/accounting/totalDocument'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'closingOpeningDocument',
          path: 'accounting/closingOpeningDocument',
          component: () => import('@/views/dashboard/pages/accounting/closingOpeningDocument'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'closeDocumentAccount',
          path: 'accounting/closeDocumentAccount',
          component: () => import('@/views/dashboard/pages/accounting/closeDocumentAccount'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'contraryNatureDocument',
          path: 'accounting/contraryNatureDocument',
          component: () => import('@/views/dashboard/pages/accounting/contraryNature'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'documentNumbering',
          path: 'accounting/documentNumbering',
          component: () => import('@/views/dashboard/pages/accounting/fixDocument'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'ConvertTempToPermanentDocuments',
          path: 'accounting/ConvertTempToPermanentDocuments',
          component: () => import('@/views/dashboard/pages/accounting/fixDocument'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          path: '/accounting/print/:id?',
          name: 'accountingPrint',
          meta: {
            middleware: auth,
          },
          props: true,
          component: () => import('@/views/dashboard/pages/invoice/print'),
        },
        {
          name: 'accountingEdit',
          path: 'accounting/edit/:id?',
          component: () => import('@/views/dashboard/pages/accounting/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'accountingList',
          path: 'accounting/list',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/accounting/list'),
          props: true,
        },
        {
          name: 'taxBooks',
          path: 'accounting/taxBooks',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/accounting/taxBooks'),
          props: true,
        },
        {
          name: 'conflictingDocuments',
          path: 'accounting/conflictingDocumentsList',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/accounting/list'),
          props: true,
        },
        {
          name: 'sell',
          path: 'sell/index',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/index'),
          props: true,
        },
        {
          name: 'reservedItems',
          path: 'sell/reserved/items',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/reservedItemsList.vue'),
          props: true,
        },
        {
          name: 'invoiceListOffline',
          path: 'sell/offline/list',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/listOffline.vue'),
          props: true,
        },
        // CashRegister (never used)
        {
          name: 'CashRegister',
          path: 'sell/cash-register',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/CashRegister/index.vue'),
          props: true,
        },
        // cashier (new version)
        {
          name: 'invoiceCasher_',
          path: 'sell/indexCasher_',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/indexCategory.vue'),
          props: true,
        },
        {
          name: 'returnSellCasher_',
          path: 'sell/returnSellCasher_',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/indexCategory.vue'),
          props: true,
        },
        {
          name: 'invoiceCasherEdit_',
          path: 'sell/edit/indexCasher_/:id?',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/indexCategory.vue'),
          props: true,
        },
        // cashier (old version)
        {
          name: 'invoiceCasher',
          path: 'sell/indexCasher',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/indexCategory(old).vue'),
          props: true,
        },
        {
          name: 'returnSellCasher',
          path: 'sell/returnSellCasher',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/indexCategory(old).vue'),
          props: true,
        },
        {
          name: 'invoiceCasherEdit',
          path: 'sell/edit/indexCasher/:id?',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/indexCategory(old).vue'),
          props: true,
        },
        {
          path: '/invoice/print/:id?',
          name: 'invoicePrint',
          meta: {
            middleware: auth,
          },
          props: true,
          component: () => import('@/views/dashboard/pages/invoice/print'),
        },
        {
          path: '/rollprint/invoice/:id?',
          name: 'invoiceRollprint',
          meta: {
            middleware: auth,
          },
          props: true,
          component: () => import('@/views/dashboard/pages/invoice/rollPrint'),
        },
        {
          name: 'sellList',
          path: 'sell/list',
          component: () => import('@/views/dashboard/pages/invoice/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'sellTaxPayer',
          path: 'sell/taxPayerList',
          component: () => import('@/views/dashboard/pages/invoice/taxPayerSellList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'digikalaOrderList',
          path: 'orders/digikala/list',
          component: () => import('@/views/dashboard/pages/invoice/digikalaOrderList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'digikalaOrderItemsList',
          path: 'orders/digikala/items',
          component: () => import('@/views/dashboard/pages/invoice/digikalaOrderItemsList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'digikalaBackOrderItemsList',
          path: 'backorders/digikala/items',
          component: () => import('@/views/dashboard/pages/invoice/digikalaOrderItemsList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'commissionList',
          path: 'cost/commission/list',
          component: () => import('@/views/dashboard/pages/cost&income/costList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'sellItemsList',
          path: 'sell/itemsList',
          component: () => import('@/views/dashboard/pages/invoice/itemsList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'sellInvestor',
          path: 'sell/investorList',
          component: () => import('@/views/dashboard/pages/invoice/investorList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'sellProductReport',
          path: 'sell/productItemReport',
          component: () => import('@/views/dashboard/pages/invoice/typeItemsList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'reportStatusTask',
          path: 'task/reportStatusTask',
          component: () => import('@/views/dashboard/pages/task/reportStatusTask.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'purchaseProductReport',
          path: 'purchase/productItemReport',
          component: () => import('@/views/dashboard/pages/invoice/typeItemsList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'sellItemsInvestor',
          path: 'sell/itemsInvestorList',
          component: () => import('@/views/dashboard/pages/invoice/itemsInvesstorList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'returnSellInvestor',
          path: 'returnSell/investorList',
          component: () => import('@/views/dashboard/pages/invoice/investorList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'returnSellItemsInvestor',
          path: 'returnSell/itemsInvestorList',
          component: () => import('@/views/dashboard/pages/invoice/itemsInvesstorList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'sellIProductGroupItemsList',
          path: 'sell/productGroupList',
          component: () => import('@/views/dashboard/pages/invoice/productItemsList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'sellIProductItemsList',
          path: 'sell/productItemsList',
          component: () => import('@/views/dashboard/pages/invoice/productItemsList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        ///add cost & income report
        {
          name: 'costIncomeReport',
          path: 'report/costIncomeReport',
          component: () => import('@/views/dashboard/pages/cost&income/costIncomeReport.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        // allocation report
        {
          name: 'allocationReport',
          path: 'report/allocation',
          component: () => import('@/views/dashboard/pages/invoice/allocationList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'presaleProductItemsList',
          path: 'presale/productItemsList',
          component: () => import('@/views/dashboard/pages/invoice/productItemsList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'purchaseProductItemsList',
          path: 'purchase/productItemsList',
          component: () => import('@/views/dashboard/pages/invoice/productItemsList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'returnPurchaseProductItemsList',
          path: 'returnPurchase/productItemsList',
          component: () => import('@/views/dashboard/pages/invoice/productItemsList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'returnSellProductItemsList',
          path: 'returnSell/productItemsList',
          component: () => import('@/views/dashboard/pages/invoice/productItemsList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'purchaseItemsList',
          path: 'purchase/itemsList',
          component: () => import('@/views/dashboard/pages/invoice/itemsList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'returnPurchaseItemsList',
          path: 'returnPurchase/itemsList',
          component: () => import('@/views/dashboard/pages/invoice/itemsList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'returnSellItemsList',
          path: 'returnSell/itemsList',
          component: () => import('@/views/dashboard/pages/invoice/itemsList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'presaleItemsList',
          path: 'presale/itemsList',
          component: () => import('@/views/dashboard/pages/invoice/itemsList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'sellEdit',
          path: 'sell/edit/:id?',
          component: () => import('@/views/dashboard/pages/invoice/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'presale',
          path: 'presale/index',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/index'),
          props: true,
        },
        {
          name: 'removedInvoices',
          path: 'invoices/removedList',
          component: () => import('@/views/dashboard/pages/invoice/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'presaleList',
          path: 'presale/list',
          component: () => import('@/views/dashboard/pages/invoice/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'presaleEdit',
          path: 'presale/edit/:id?',
          component: () => import('@/views/dashboard/pages/invoice/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'returnSell',
          path: 'returnSell/index',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/index'),
          props: true,
        },
        {
          name: 'returnSellList',
          path: 'returnSell/list',
          component: () => import('@/views/dashboard/pages/invoice/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'returnSellEdit',
          path: 'returnSell/edit/:id?',
          component: () => import('@/views/dashboard/pages/invoice/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'returnPurchase',
          path: 'returnPurchase/index',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/index'),
          props: true,
        },
        {
          name: 'returnPurchaseList',
          path: 'returnPurchase/list',
          component: () => import('@/views/dashboard/pages/invoice/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'returnPurchaseEdit',
          path: 'returnPurchase/edit/:id?',
          component: () => import('@/views/dashboard/pages/invoice/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'purchase',
          path: 'purchase/new',
          component: () => import('@/views/dashboard/pages/invoice/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'purchaseList',
          path: 'purchase/list',
          component: () => import('@/views/dashboard/pages/invoice/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'purchaseEdit',
          path: 'purchase/edit/:id?',
          component: () => import('@/views/dashboard/pages/invoice/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'bank',
          path: 'bank/index',
          component: () => import('@/views/dashboard/pages/treasury/bank'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'bankList',
          path: 'bank/list',
          component: () => import('@/views/dashboard/pages/treasury/bankList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'bankEdit',
          path: 'bank/edit/:id?',
          component: () => import('@/views/dashboard/pages/treasury/bank'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'cash',
          path: 'cash/index',
          component: () => import('@/views/dashboard/pages/treasury/bank'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'cashList',
          path: 'cash/list',
          component: () => import('@/views/dashboard/pages/treasury/bankList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'cashEdit',
          path: 'cash/edit/:id?',
          component: () => import('@/views/dashboard/pages/treasury/bank'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'petty',
          path: 'petty/index',
          component: () => import('@/views/dashboard/pages/treasury/bank'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'pettyList',
          path: 'petty/list',
          component: () => import('@/views/dashboard/pages/treasury/bankList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'pettyEdit',
          path: 'petty/edit/:id?',
          component: () => import('@/views/dashboard/pages/treasury/bank'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'detail',
          path: 'detail/index',
          component: () => import('@/views/dashboard/pages/account/detail'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'detailList',
          path: 'detail/list',
          component: () => import('@/views/dashboard/pages/account/detailList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'detailEdit',
          path: 'detail/edit/:id?',
          component: () => import('@/views/dashboard/pages/account/detail'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'checkpage',
          path: 'checkpage/index',
          component: () => import('@/views/dashboard/pages/treasury/checkpage'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'checkpageList',
          path: 'checkpage/list',
          component: () => import('@/views/dashboard/pages/treasury/checkpageList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'payCheck',
          path: 'check/pay/index',
          component: () => import('@/views/dashboard/pages/treasury/check'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'removedChecks',
          path: 'check/removedChecks',
          component: () => import('@/views/dashboard/pages/treasury/checksList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'payCheckList',
          path: 'check/pay/list',
          component: () => import('@/views/dashboard/pages/treasury/checksList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        //check sheet
        {
          name: 'checkSheetsList',
          path: 'check/sheets/list',
          component: () => import('@/views/dashboard/pages/treasury/checkSheetsList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'payCheckEdit',
          path: 'check/pay/edit/:id?',
          component: () => import('@/views/dashboard/pages/treasury/check'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'recieveCheck',
          path: 'check/recieve/index',
          component: () => import('@/views/dashboard/pages/treasury/check'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'recieveCheckList',
          path: 'check/recieve/list',
          component: () => import('@/views/dashboard/pages/treasury/checksList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'recieveCheckEdit',
          path: 'check/recieve/edit/:id?',
          component: () => import('@/views/dashboard/pages/treasury/check'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'translationOrder',
          path: 'translation/order',
          component: () => import('@/views/dashboard/pages/translation/order'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'translationOrderEdit',
          path: 'translation/order/edit/:id?',
          component: () => import('@/views/dashboard/pages/translation/order'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          path: '/translation/print/:id?',
          name: 'translationPrint',
          meta: {
            middleware: auth,
          },
          props: true,
          component: () => import('@/views/dashboard/pages/translation/print'),
        },
        {
          path: '/translation/translatorprint/:id?',
          name: 'translationTranslatorPrint',
          meta: {
            middleware: auth,
          },
          props: true,
          component: () => import('@/views/dashboard/pages/translation/translatorPrint'),
        },
        {
          name: 'translationList',
          path: 'translation/list',
          component: () => import('@/views/dashboard/pages/translation/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'translationOrderItemsList',
          path: 'translation/order/itemslist',
          component: () => import('@/views/dashboard/pages/translation/itemsList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'translationPrice',
          path: 'translation/price/index',
          component: () => import('@/views/dashboard/pages/translation/price'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'translationPriceEdit',
          path: 'translation/price/edit/:id?',
          component: () => import('@/views/dashboard/pages/translation/price'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'translationPriceList',
          path: 'translation/price/list',
          component: () => import('@/views/dashboard/pages/translation/priceList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'role',
          path: 'role/index',
          component: () => import('@/views/dashboard/pages/General/role'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'roleList',
          path: 'role/list',
          component: () => import('@/views/dashboard/pages/General/roleList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'roleEdit',
          path: 'role/edit/:id?',
          component: () => import('@/views/dashboard/pages/General/role'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'year',
          path: 'accounting/year/index',
          component: () => import('@/views/dashboard/pages/accounting/year'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'yearList',
          path: 'accounting/year/list',
          component: () => import('@/views/dashboard/pages/accounting/yearList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'yearEdit',
          path: 'accounting/year/edit/:id?',
          component: () => import('@/views/dashboard/pages/accounting/year'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'rolePermissons',
          path: 'role/permissions',
          component: () => import('@/views/dashboard/pages/General/permissions'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'entrepot',
          path: 'entrepot/index',
          component: () => import('@/views/dashboard/pages/Entrepot/entrepot'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          path: '/entrepot/receipt/print/:id?',
          name: 'receiptPrint',
          meta: {
            middleware: auth,
          },
          props: true,
          component: () => import('@/views/dashboard/pages/Entrepot/print'),
        },
        {
          path: '/entrepot/remittance/print/:id?',
          name: 'remittancePrint',
          meta: {
            middleware: auth,
          },
          props: true,
          component: () => import('@/views/dashboard/pages/Entrepot/print'),
        },
        // add print path for entrepot tempReceipt
        {
          path: '/entrepot/tempReceipt/print/:id?',
          name: 'tempReceiptPrint',
          component: () => import('@/views/dashboard/pages/Entrepot/print'),
        },
        //
        // add print path for entrepot warehousehandling
        {
          path: '/entrepot/warehouseHandling/print/:id?',
          name: 'warehouseHandlingPrint',
          // meta: { middleware: auth },
          // props: true,
          component: () => import('@/views/dashboard/pages/Entrepot/print'),
        },
        //
        {
          path: '/entrepot/receipt/checkout/:id?',
          name: 'receiptCheckout',
          meta: {
            middleware: auth,
          },
          props: true,
          component: () => import('@/views/dashboard/pages/Entrepot/checkout.vue'),
        },
        {
          path: '/entrepot/tempReceipt/checkout/:id?',
          name: 'tempReceiptCheckout',
          meta: {
            middleware: auth,
          },
          props: true,
          component: () => import('@/views/dashboard/pages/Entrepot/checkout.vue'),
        },
        {
          path: '/entrepot/remittance/checkout/:id?',
          name: 'remittanceCheckout',
          meta: {
            middleware: auth,
          },
          props: true,
          component: () => import('@/views/dashboard/pages/Entrepot/checkout.vue'),
        },
        {
          path: '/entrepot/useRemittance/print/:id?',
          name: 'useRemittancePrint',
          meta: {
            middleware: auth,
          },
          props: true,
          component: () => import('@/views/dashboard/pages/Entrepot/print'),
        },
        {
          path: '/entrepot/transferRemittance/print/:id?',
          name: 'transferRemittancePrint',
          meta: {
            middleware: auth,
          },
          props: true,
          component: () => import('@/views/dashboard/pages/Entrepot/print'),
        },
        {
          name: 'entrepotEdit',
          path: 'entrepot/edit/:id?',
          component: () => import('@/views/dashboard/pages/Entrepot/entrepot'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'entrepotList',
          path: 'entrepot/list',
          component: () => import('@/views/dashboard/pages/Entrepot/entrepotList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'turnover',
          path: 'report/turnover',
          component: () => import('@/views/dashboard/pages/accounting/turnover'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'accountingGroup',
          path: 'accounting/group/list',
          component: () => import('@/views/dashboard/pages/accounting/groupList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'accountingTotal',
          path: 'accounting/total/list',
          component: () => import('@/views/dashboard/pages/accounting/totalList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'accountingGroupChild',
          path: 'accounting/group/:id?',
          component: () => import('@/views/dashboard/pages/accounting/totalList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'accountingTotalChild',
          path: 'accounting/total/:id?',
          component: () => import('@/views/dashboard/pages/accounting/givenList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'accountingGiven',
          path: 'accounting/given/list',
          component: () => import('@/views/dashboard/pages/accounting/givenList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'turnoverDetail',
          path: 'report/turnoverlist/:id?/:type?',
          component: () => import('@/views/dashboard/pages/accounting/turnover'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'coding',
          path: 'accounting/coding',
          component: () => import('@/views/dashboard/pages/accounting/coding'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'accountingBook',
          path: 'accounting/book',
          component: () => import('@/views/dashboard/pages/accounting/book'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'accountingBalance',
          path: 'accounting/balance',
          component: () => import('@/views/dashboard/pages/accounting/balance'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'configControl',
          path: 'management/user',
          component: () => import('@/views/dashboard/pages/setting/config'),
        },
        {
          name: 'settingPage',
          path: 'setting/index',
          component: () => import('@/views/dashboard/pages/setting/setting'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'settingIntegrator',
          path: 'setting/integrator',
          component: () => import('@/views/dashboard/pages/setting/integrator'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'settingPortal',
          path: 'setting/portal',
          component: () => import('@/views/dashboard/pages/setting/settingPortal'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'settingWoo',
          path: 'setting/woocommerce',
          component: () => import('@/views/dashboard/pages/setting/settingPortal'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'currencyList',
          path: 'currency/list',
          component: () => import('@/views/dashboard/pages/General/currencyList'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'currency',
          path: 'currency/index',
          component: () => import('@/views/dashboard/pages/General/currency'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'currencyEdit',
          path: 'currency/edit/:id?',
          component: () => import('@/views/dashboard/pages/General/currency'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'review',
          path: 'report/review',
          component: () => import('@/views/dashboard/pages/accounting/review'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'profit&cost',
          path: 'report/profitCost',
          component: () => import('@/views/dashboard/pages/accounting/review'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'productionDetailsList',
          path: 'production/report/items',
          component: () => import('@/views/dashboard/pages/production/itemsList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'formulaDetailsList',
          path: 'formula/report/items',
          component: () => import('@/views/dashboard/pages/production/itemsList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'formula',
          path: 'formula/index',
          component: () => import('@/views/dashboard/pages/production/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'bundling',
          path: 'bundling/index',
          component: () => import('@/views/dashboard/pages/production/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'bundlingEdit',
          path: 'bundling/edit/:id?',
          component: () => import('@/views/dashboard/pages/production/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'bundlingList',
          path: 'bundling/list',
          component: () => import('@/views/dashboard/pages/production/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'formulaEdit',
          path: 'formula/edit/:id?',
          component: () => import('@/views/dashboard/pages/production/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'formulaList',
          path: 'formula/list',
          component: () => import('@/views/dashboard/pages/production/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'production',
          path: 'production/index',
          component: () => import('@/views/dashboard/pages/production/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'productionEdit',
          path: 'production/edit/:id?',
          component: () => import('@/views/dashboard/pages/production/index'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'productionList',
          path: 'production/list',
          component: () => import('@/views/dashboard/pages/production/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'bundlingProductionList',
          path: 'bundlingProduction/list',
          component: () => import('@/views/dashboard/pages/production/list'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'shopInitialize',
          path: 'shop/initialize',
          component: () => import('@/views/dashboard/pages/shop/initialize'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'taxPayerSystemSetting',
          path: 'setting/taxPayerSystem',
          component: () => import('@/views/dashboard/pages/setting/taxPayerSystem.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'logList',
          path: 'users/log',
          component: () => import('@/views/dashboard/pages/General/log.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          path: '/cashPayment/invoice/:id?',
          name: 'cashPayment',
          props: true,
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/generalPrint'),
        },
        {
          name: 'reportProductProfitableItems',
          path: 'invoice/report/productProfitable',
          component: () => import('@/views/dashboard/pages/invoice/reportProductProfitable.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'invoiceAndStockComparison',
          path: 'invoice/report/invoiceAndStockComparison',
          component: () => import('@/views/dashboard/pages/invoice/invoiceAndStockComparison.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          name: 'reportProcessingProductCost',
          path: 'product/report/processingList',
          component: () => import('@/views/dashboard/pages/product/reportProcessingList.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        // {
        //   path: '/ticket',
        //   name: 'userSupport',
        //   meta: {
        //     middleware: auth,
        //   },
        //   component: () => import('@/views/dashboard/pages/ticket/ticket.vue'),
        //   props: true,
        // },
        {
          path: '/ticket',
          name: 'userSupport',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/ticket/ticket.vue'),
          props: true,
        },
        {
          path: '/departman',
          name: 'departman',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/departman/departman.vue'),
          props: true,
        },
        {
          path: '/branches/list',
          name: 'branchesList',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/branches/list.vue'),
          props: true,
        },
        {
          path: '/group/main/list',
          name: 'mainGroup',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/group/mainGroup.vue'),
          props: true,
        },
        {
          path: '/group/sub/list',
          name: 'subGroup',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/group/subGroup.vue'),
          props: true,
        },
        {
          path: '/category/list',
          name: 'category',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/group/category.vue'),
          props: true,
        },
        {
          path: '/plan-administration/index',
          name: 'planAdministration',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/plan-administration/index.vue'),
          props: true,
        },
        {
          name: 'menu-settings',
          path: '/setting/menuSettings',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/marketplace/menuSettings.vue'),
          props: true,
        },
        {
          path: '/ticketReport',
          name: 'ticketReport',
          component: () => import('@/views/dashboard/pages/ticketReport/index.vue'),
          meta: { middleware: auth },
          props: true,
        },
        // integrator 
        {
          path: '/integrator/digikala',
          name: 'integratorDigikala',
          component: () => import('@/views/dashboard/pages/integrator/index.vue'),
          meta: { middleware: auth },
          props: { path: 'channels/digikala' },
        },
        {
          path: '/integrator/sazito',
          name: 'integratorSazito',
          component: () => import('@/views/dashboard/pages/integrator/index.vue'),
          meta: { middleware: auth },
          props: { path: 'channels/sazito' },
        },
        {
          path: '/integrator/portal#V3',
          name: 'integratorPortal#V3',
          component: () => import('@/views/dashboard/pages/integrator/index.vue'),
          meta: { middleware: auth },
          props: { path: 'channels/portal' },
        },
        {
          path: '/integrator/magnet',
          name: 'integratorMagnet',
          component: () => import('@/views/dashboard/pages/integrator/index.vue'),
          meta: { middleware: auth },
          props: { path: 'clubs/magnet' },
        },
        {
          path: '/integrator/dobare',
          name: 'integratorDobare',
          component: () => import('@/views/dashboard/pages/integrator/index.vue'),
          meta: { middleware: auth },
          props: { path: 'clubs/dobare' },
        },
        {
          path: '/integrator/mixin',
          name: 'integratorMixin',
          component: () => import('@/views/dashboard/pages/integrator/index.vue'),
          meta: { middleware: auth },
          props: { path: 'channels/mixin' },
        },
        {
          path: '/integrator/baSalam',
          name: 'integratorBasalam',
          component: () => import('@/views/dashboard/pages/integrator/index.vue'),
          meta: { middleware: auth },
          props: { path: 'channels/basalam' },
        },
        {
          path: '/integrator/integratorAfra',
          name: 'integratorAfra',
          component: () => import('@/views/dashboard/pages/integrator/index.vue'),
          meta: { middleware: auth },
          props: { path: 'clubs/afra' },
        },
        //ai dashboard
        {
          path: '/dashboard/aiDashboard',
          name: 'aiDashboard',
          component: () => import('@/views/dashboard/pages/aiDashboard/index.vue'),
          meta: {
            middleware: auth,
          },
          // props: { path: 'overview' },
          props: true,
        },
        {
          path: '/ai-cfo/overview',
          name: 'aiCfoOverview',
          component: () => import('@/views/dashboard/pages/aiDashboard/index.vue'),
          meta: { middleware: auth },
          props: { path: 'overview' },
        },
        {
          path: '/ai-cfo/sales',
          name: 'aiCfoSales',
          component: () => import('@/views/dashboard/pages/aiDashboard/index.vue'),
          meta: { middleware: auth },
          props: { path: 'sales' },
        },
        {
          path: '/ai-cfo/purchase',
          name: 'aiCfoPurchase',
          component: () => import('@/views/dashboard/pages/aiDashboard/index.vue'),
          meta: { middleware: auth },
          props: { path: 'purchase' },
        },
        {
          path: '/ai-cfo/customers',
          name: 'aiCfoCustomers',
          component: () => import('@/views/dashboard/pages/aiDashboard/index.vue'),
          meta: { middleware: auth },
          props: { path: 'customers' },
        },
        {
          path: '/ai-cfo/suppliers',
          name: 'aiCfoSuppliers',
          component: () => import('@/views/dashboard/pages/aiDashboard/index.vue'),
          meta: { middleware: auth },
          props: { path: 'suppliers' },
        },
        {
          path: '/ai-cfo/cost-income',
          name: 'aiCfoCostIncome',
          component: () => import('@/views/dashboard/pages/aiDashboard/index.vue'),
          meta: { middleware: auth },
          props: { path: 'cost-income' },
        },
        {
          path: '/ai-cfo/accounting',
          name: 'aiCfoAccounting',
          component: () => import('@/views/dashboard/pages/aiDashboard/index.vue'),
          meta: { middleware: auth },
          props: { path: 'accounting' },
        },
        {
          path: '/ai-cfo/inventory',
          name: 'aiCfoInventory',
          component: () => import('@/views/dashboard/pages/aiDashboard/index.vue'),
          meta: { middleware: auth },
          props: { path: 'inventory' },
        },
        {
          path: '/ai-cfo/treasury',
          name: 'aiCfoTreasury',
          component: () => import('@/views/dashboard/pages/aiDashboard/index.vue'),
          meta: { middleware: auth },
          props: { path: 'treasury' },
        },
        {
          path: '/ai-cfo/payroll',
          name: 'aiCfoPayroll',
          component: () => import('@/views/dashboard/pages/aiDashboard/index.vue'),
          meta: { middleware: auth },
          props: { path: 'payroll' },
        },
        {
          path: '/ai-cfo/moadian',
          name: 'aiCfoMoadian',
          component: () => import('@/views/dashboard/pages/aiDashboard/index.vue'),
          meta: { middleware: auth },
          props: { path: 'moadian' },
        },
        {
          path: '/ai-cfo/settings',
          name: 'aiCfoSettings',
          component: () => import('@/views/dashboard/pages/aiDashboard/index.vue'),
          meta: { middleware: auth },
          props: { path: 'settings' },
        },
        //bi dashboard
        {
          path: '/dashboard/BIdashboard',
          name: 'biDashboard',
          component: () => import('@/views/dashboard/pages/biDashboard/dashboard/index.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/dashboard/BIsell',
          name: 'bIsell',
          component: () => import('@/views/dashboard/pages/biDashboard/sell/index.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/dashboard/BIbuy',
          name: 'bIbuy',
          component: () => import('@/views/dashboard/pages/biDashboard/buy/index.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/dashboard/BIwarehouse',
          name: 'bIwarehouse',
          component: () => import('@/views/dashboard/pages/biDashboard/warehouse/index.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/dashboard/BIcosts',
          name: 'bIcosts',
          component: () => import('@/views/dashboard/pages/biDashboard/costs/index.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/dashboard/BIpetty',
          name: 'bIpetty',
          component: () => import('@/views/dashboard/pages/biDashboard/petty/index.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/dashboard/BIpaybox',
          name: 'bIpaybox',
          component: () => import('@/views/dashboard/pages/biDashboard/paybox/index.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/dashboard/CRM',
          name: 'crm',
          component: () => import('@/views/dashboard/pages/biDashboard/CRM/index.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/dashboard/BIproduction',
          name: 'generation',
          component: () => import('@/views/dashboard/pages/biDashboard/generation/index.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/dashboard/BItaxPayerSystem',
          name: 'taxPayerSystem',
          component: () => import('@/views/dashboard/pages/biDashboard/taxPayerSystem/index.vue'),
          meta: {
            middleware: auth,
          },
        },
        //
        //payroll
        {
          path: '/payroll/workshop',
          name: 'workshop',
          component: () => import('@/views/dashboard/pages/payroll/workshop/List.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/payroll/workshop/create',
          name: 'new_workshop',
          component: () => import('@/views/dashboard/pages/payroll/workshop/index.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/payroll/workshop/edit/:id?',
          name: 'workshop_edit',
          component: () => import('@/views/dashboard/pages/payroll/workshop/index.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          path: '/payroll/personnel',
          name: 'personel',
          component: () => import('@/views/dashboard/pages/payroll/personnel/List.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/payroll/commandments',
          name: 'commandments',
          component: () => import('@/views/dashboard/pages/payroll/commandments/List.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/payroll/commandments/personnel/:id?',
          name: 'commandments_By_id',
          component: () => import('@/views/dashboard/pages/payroll/commandments/List.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          path: '/payroll/commandments/create',
          name: 'new_commandments',
          component: () => import('@/views/dashboard/pages/payroll/commandments/index.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          path: '/payroll/commandments/edit',
          name: 'commandments_edit',
          component: () => import('@/views/dashboard/pages/payroll/commandments/index.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          path: '/payroll/salery_factors/create',
          name: 'new_salery_factors',
          component: () => import('@/views/dashboard/pages/payroll/saleryFactors/List.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/payroll/salery_factors/edit/:id?',
          name: 'edit_salery_factors',
          component: () => import('@/views/dashboard/pages/payroll/saleryFactors/List.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          path: '/payroll/salery_factors',
          name: 'salery_factors',
          component: () => import('@/views/dashboard/pages/payroll/saleryFactors/index.vue'),
          meta: {
            middleware: auth,
          },
        },
        //salery_operations
        {
          path: '/payroll/salery_operations/create',
          name: 'new_salery_operations',
          component: () => import('@/views/dashboard/pages/payroll/saleryOperations/List.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/payroll/salery_operations',
          name: 'salery_operations',
          component: () => import('@/views/dashboard/pages/payroll/saleryOperations/index.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/payroll/salery_operations_list',
          name: 'salery_operations_list',
          component: () => import('@/views/dashboard/pages/payroll/saleryOperations/PersonelList.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/payroll/salery_operations/edit',
          name: 'edit_salery_operations',
          component: () => import('@/views/dashboard/pages/payroll/saleryOperations/List.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        {
          path: '/payroll/salary_documents',
          name: 'salary_documents',
          component: () => import('@/views/dashboard/pages/payroll/saleryOperations/Documents.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        //contracts
        {
          path: '/payroll/contract_list',
          name: 'contract_list',
          component: () => import('@/views/dashboard/pages/payroll/contracts/List.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/payroll/contract_print',
          name: 'contract_print',
          component: () => import('@/views/dashboard/pages/payroll/contracts/PrintContract.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/payroll/contract/create',
          name: 'contract_create',
          component: () => import('@/views/dashboard/pages/payroll/contracts/index.vue'),
          meta: {
            middleware: auth,
          },
        },
        {
          path: '/payroll/contract/edit/:id?',
          name: 'contract_edit',
          component: () => import('@/views/dashboard/pages/payroll/contracts/index.vue'),
          meta: {
            middleware: auth,
          },
          props: true,
        },
        //resturant
        {
          path: 'restaurant/halls',
          name: 'restaurant-halls',
          meta: { middleware: auth },
          component: () => import('@/views/dashboard/pages/resturant/HallsPage.vue'),
          props: true,
        },
        {
          path: 'restaurant/tables',
          name: 'restaurant-tables',
          meta: { middleware: auth },
          component: () => import('@/views/dashboard/pages/resturant/TablesPage.vue'),
          props: true,
        },
        {
          path: 'restaurant/kitchens',
          name: 'restaurant-kitchens',
          meta: { middleware: auth },
          component: () => import('@/views/dashboard/pages/resturant/KitchensPage.vue'),
          props: true,
        },
        {
          path: 'restaurant/menu-categories',
          name: 'restaurant-menu-categories',
          meta: { middleware: auth },
          component: () => import('@/views/dashboard/pages/General/test.vue'),
          props: true,
        },
        {
          path: 'restaurant/menu-items',
          name: 'restaurant-menu-items',
          meta: { middleware: auth },
          component: () => import('@/views/dashboard/pages/General/test.vue'),
          props: true,
        },
        //
      ],
    },
    {
      name: 'mobileDashboard',
      path: '/mobileDashboard',
      meta: {
        middleware: auth,
      },
      component: () => import('@/views/dashboard/Dashboard'),
    },
    {
      path: '/mDash',
      component: () => import('@/views/dashboard/mobileIndex.vue'),
      children: [
        {
          name: 'mDashboard',
          path: '',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/mDashboard.vue'),
        },
        {
          name: 'mSell',
          path: '/mSell/index',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/mobileIndex.vue'),
        },
        {
          name: 'mReturnSell',
          path: '/mReturnSell/index',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/mobileIndex.vue'),
        },
        {
          name: 'mSellList',
          path: '/mSell/list',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/mobileList.vue'),
        },
        {
          name: 'mCustomer',
          path: '/mCustomer/index',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/mobileList.vue'),
        },
        {
          name: 'mCustomerList',
          path: '/mCustomer/list',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/account/mobileList.vue'),
        },
        {
          name: 'mProductList',
          path: '/mProduct/list',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/product/mobileList.vue'),
        },
        {
          name: 'mReturnSellList',
          path: '/mReturnSell/list',
          meta: {
            middleware: auth,
          },
          component: () => import('@/views/dashboard/pages/invoice/mobileList.vue'),
        },

      ],
    },
    // login
    {
      path: '/login',
      name: 'login',
      props: true,
      meta: {
        middleware: loggedIn,
      },
      component: () => import('@/views/dashboard/pages/login-register/index.vue'),
    },
    {
      path: '/mlogin',
      name: 'mlogin',
      props: true,
      meta: {
        middleware: loggedIn,
      },
      component: () => import('@/views/dashboard/pages/login-register/index.vue'),
    },
    {
      path: '/print/index',
      name: 'Print',
      component: () => import('@/views/dashboard/components/general/Print/Index'),
      props: true,
      meta: {
        middleware: auth,
      },
    },
    {
      path: '/shopInvoice',
      name: 'shopInvoice',
      component: () => import('@/views/dashboard/pages/invoice/shopInvoice.vue'),
      props: true,
      meta: {
        middleware: auth,
      },
    },
    // logout
    {
      path: '/mlogout',
      name: 'mlogout',
      meta: {
        middleware: logout,
      },
      component: () => import('@/views/dashboard/pages/login-register/index.vue'),
    },
    {
      path: '/logout',
      name: 'logout',
      meta: {
        middleware: logout,
      },
      component: () => import('@/views/dashboard/pages/login-register/index.vue'),
    }, // logout
    {
      path: '/403',
      name: '403',
      props: true,
      component: () => import('@/views/dashboard/pages/General/403'),
    }, // 403
    // {
    //   path: '/register/index',
    //   name: 'register',
    //   props: true,
    //   component: () => import('@/views/dashboard/pages/register/index'),
    // },
    {
      path: '/register/index',
      name: 'login',
      props: true,
      component: () => import('@/views/dashboard/pages/login-register/index.vue'),
    },
    {
      path: '/register/plan',
      name: 'registerPlan',
      props: true,
      component: () => import('@/views/dashboard/pages/register/plan'),
    },

    {
      path: '/register/shop',
      name: 'registerShop',
      props: true,
      component: () => import('@/views/dashboard/pages/register/shop'),
    },
    {
      path: '/register/initial',
      name: 'registerInitial',
      props: true,
      component: () => import('@/views/dashboard/pages/register/initial'),
    },
    {
      path: '/register/finish',
      name: 'registerFinish',
      props: true,
      component: () => import('@/views/dashboard/pages/register/finish'),
    },
    {
      path: '/pricing/index',
      name: 'pricing',
      props: true,
      component: () => import('@/views/dashboard/pages/register/pricing.vue'),
    },
    {
      path: '/email/verification',
      name: 'forgetPassword',
      props: true,
      component: () => import('@/views/dashboard/pages/register/forgetPassword'),
    },
    {
      path: '/print/invoice/:id?',
      name: 'generalPrint',
      // component: () => import('@/views/dashboard/pages/invoice/generalPrint'),
      props: true,
      component: () =>
        import('@/views/dashboard/pages/invoice/PayFlowInvoice/generalPrintNew'),
    },
    {
      path: '/print/invoice-v2/:id?',
      name: 'generalPrintV2',
      props: true,
      component: () =>
        import('@/views/dashboard/pages/invoice/PayFlowInvoice/generalPrintNew'),
    },
    {
      path: '/pi/:id?',
      name: 'invoiceIncomePrint',
      props: true,
      component: () => import('@/views/dashboard/pages/cost&income/print'),
    },
    {
      path: '/password/reset',
      name: 'resetPassword',
      props: true,
      component: () => import('@/views/dashboard/pages/register/resetPassword'),
    },
    //dynamic getway
    {
      path: '/payment/:gateway/verify',
      name: 'paymentVerify',
      props: true,
      component: () => import('@/views/dashboard/pages/General/PaymentVerify'),
    },
    //
    {
      path: '/payment/zibal/verify',
      name: 'zibalVerify',
      props: true,
      component: () => import('@/views/dashboard/pages/General/zibalVerify'),
    },
    {
      name: 'academyStudentRegister',
      path: '/academy/student/register',
      component: () => import('@/views/dashboard/pages/academy/studentRegister'),
      props: true,
    },
    {
      name: 'websitePricing',
      path: '/website/pricing',
      component: () => import('@/views/dashboard/pages/General/pricing.vue'),
      props: true,
    },
    {
      name: 'testui',
      path: '/ui/test',
      component: () => import('@/views/dashboard/pages/General/test.vue'),
      props: true,
    },
    {
      name: 'submitPanel',
      path: '/submitPanel',
      component: () => import('@/views/dashboard/pages/General/submitPanel.vue'),
      props: true,
    },
    {
      name: 'businessInfo',
      path: '/business-Info',
      // meta: {
      //   middleware: auth,
      // },
      component: () => import('@/views/dashboard/pages/business-info/index.vue'),
      props: true,
    },
    {
      name: 'PlansResult',
      path: '/plans/result',
      component: () => import('@/views/dashboard/pages/plans/partial/result.vue'),
      props: true,
    },
    {
      path: '/plans',
      name: 'plans',
      component: () => import('@/views/dashboard/pages/plans/index.vue'),
      props: true,
    },
    {
      path: '/plans/checkout',
      name: 'PlansCheckout',
      component: () => import('@/views/dashboard/pages/plans/partial/checkout.vue'),
      props: true,
    },
    {
      name: 'online-shop',
      path: '/onlineShop/:uid/:hash',
      // meta: {
      //   middleware: auth,
      // },
      //remove auth
      component: () => import('@/views/dashboard/pages/marketplace/index.vue'),
      props: true,
    }
  ],
})

// control routes by middle ware // old
router.beforeEach(async (to, from, next) => {
  var appKey = localStorage.getItem('APP_KEY')
  // axios.defaults.headers.common.domain = appKey
  if (!to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware
  const context = {
    to,
    from,
    next,
  }
  return middleware(context)
})


export default router
